// The offline banner: shown while the browser reports no connection. The sample data is local, so the
// app keeps working; only a newer version waits for the connection. role="status" announces the change.

import { Glyph } from "../../components/Glyph";
import { cx } from "../../lib/cx";
import { useT } from "../../lib/i18n";
import { useOnlineStatus } from "../../lib/pwa/useOnlineStatus";
import styles from "./shell.module.css";

export function OfflineNotice() {
  const t = useT();
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div className={cx("sf-block", styles.notice)}>
      <div className="sf-banner sf-banner--info" role="status">
        <Glyph name="info" />
        <div>
          <p className="sf-banner__title">{t("offline.title")}</p>
          <p>{t("offline.text")}</p>
        </div>
      </div>
    </div>
  );
}
